import { FC, memo } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import { Button } from 'antd';
import { useRequest } from 'ahooks';
import { apiV2LightmapElectricityPost } from '@maxtropy/device-customer-apis-v2';
import { keepTwoOrLine } from '@/utils/utils';

interface CenterTopBoxProps {
  className?: string;
}

const CenterTopBox: FC<CenterTopBoxProps> = ({ className }) => {
  const { data } = useRequest(() => apiV2LightmapElectricityPost({}));

  return (
    <div className={classNames(styles.topRow, className)}>
      {/* 本月电能数据 */}
      <div className={styles.item}>
        <div className={styles.title}>本月电能数据</div>
        <div className={styles.energyInfo}>
          <div className={styles.left}>
            <div className={styles.rowItem}>
              <div className={styles.subTitle}>车间照明用电量(kWh):</div>
              <div className={styles.value}>{keepTwoOrLine(data?.circuitElectricity)}</div>
            </div>
            <div className={styles.rowItem}>
              <div className={styles.subTitle}>高杆灯照明用电量(kWh):</div>
              <div className={styles.value}>{keepTwoOrLine(data?.ggdElectricity)}</div>
            </div>
          </div>
          <div className={styles.arrow}>
            <Button
              type="link"
              onClick={() => {
                window.open(`${window.ENERGY}/layout/home`, '_blank');
              }}
            >
              {'>>'}
            </Button>
          </div>
          <div className={styles.right}>
            <div className={styles.subTitle}>太阳能路灯节约用电量(kWh)</div>
            <div className={styles.value}>{keepTwoOrLine(data?.lightElectricity)}</div>
          </div>
        </div>
      </div>

      {/* 本年电能数据 */}
      <div className={styles.item}>
        <div className={styles.title}>本年电能数据</div>
        <div className={styles.energyInfo}>
          <div className={styles.left}>
            <div className={styles.rowItem}>
              <div className={styles.subTitle}>车间照明用电量(kWh):</div>
              <div className={styles.value}>{keepTwoOrLine(data?.yearlyCircuitElectricity)}</div>
            </div>
            <div className={styles.rowItem}>
              <div className={styles.subTitle}>高杆灯照明用电量(kWh):</div>
              <div className={styles.value}>{keepTwoOrLine(data?.yearlyGgdElectricity)}</div>
            </div>
          </div>
          <div className={styles.arrow}>
            <Button
              type="link"
              onClick={() => {
                window.open(`${window.ENERGY}/layout/home`, '_blank');
              }}
            >
              {'>>'}
            </Button>
          </div>
          <div className={styles.right}>
            <div className={styles.subTitle}>太阳能路灯节约电量(kWh)</div>
            <div className={styles.value}>{keepTwoOrLine(data?.yearlyLightElectricity)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(CenterTopBox);
